import "bootstrap/dist/css/bootstrap.min.css";
import "./FeaturesSection.css";
import featureImg from "../../../../Assets/Images/Services/Web Development/Features.svg";
import featureImgMobile from "../../../../Assets/Images/feature-img.png";
// import testImg from "../../../../Assets/Images/00test.jpg";
import custom from "../../../../Assets/Images/Services/Web Development/Innovation- icon.svg";
import responsive from "../../../../Assets/Images/Services/Web Development/Custom-Software-icon.svg";
import trends from "../../../../Assets/Images/Services/Web Development/Trends-Technologies-icon.svg";
import deadline from "../../../../Assets/Images/Services/Web Development/time-icon.svg";
import strong from "../../../../Assets/Images/Services/Web Development/Icon Wrapper.svg";
import technical from "../../../../Assets/Images/Services/Web Development/Technical.svg";

export const FeaturesSection = () => {
  return (
    <div className="features-section" id="features">
      <div className="features-container d-flex flex-column">
        {/* <div className="feature-img">
          <img
            src={featureImg}
            alt="web development feature"
            className="img-fluid"
          />
        </div> */}
        <div className="feature-img">
          <picture>
            <source media="(max-width: 675px)" srcSet={featureImgMobile} />
            <img
              src={featureImg}
              alt="Web development feature"
              className="img-fluid"
            />
          </picture>
        </div>
        <div className="dev-features">
          <div className="dev-services d-flex justify-content-between align-items-stretch">
            <h1 className="dev-services-title">
              What Makes Our Web Work Different
            </h1>
            <p className="dev-services-desc">
              What usually sets us apart comes a few months after launch. When
              traffic increases or content changes and priorities shift, our
              websites don't start fighting back. At Quad Theory Ltd we design
              web systems based on the assumption that things will change.
              Decisions are written down, structure is kept clean and short cuts
              are not taken, even if deadlines are tight. Clients tell us the
              difference isn't how the site looks on day one, but how easy it is
              to live with later, when real business pressure sets in.
            </p>
          </div>
          <div className="features">
            <ul>
              <h3>Features</h3>
              <li>
                {" "}
                <img src={custom} alt="" />
                Custom created just for real-life business flows
              </li>
              <li>
                {" "}
                <img src={responsive} alt="" />
                Mobile first designed and tested on actual devices
              </li>
              <li>
                {" "}
                <img src={trends} alt="" />
                Carefully used modern, proven technologies
              </li>
              <li>
                {" "}
                <img src={deadline} alt="" />
                Performance-oriented from day one
              </li>
              <li>
                {" "}
                <img src={strong} alt="" />
                Clear ownership and on time delivery
              </li>
              <li>
                {" "}
                <img src={technical} alt="" />
                Reliable support after launch
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
